// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"c0Ig7xsaZKllIXLOvQkQI","title":"_2mk__HZN1WGyAtIUsPbgVZ","pill":"_1wB6Py5HH2cl5r59FNWNKw","noPills":"_31ML1un-CB5xwP8YOQnhEE"};


//////////////////
// WEBPACK FOOTER
// ./elements/PillList.scss
// module id = 1182
// module chunks = 0